function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg134Croatia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.006,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "317.44,188.55 276.48,188.55 283.306,137.35 310.614,116.87 337.92,137.35 337.92,178.31     "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "194.56,188.55 235.52,188.55 228.694,137.35 201.386,116.87 174.08,137.35 174.08,178.31     "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "283.306,188.55 228.693,188.55 228.693,137.35 256,116.87 283.306,137.35 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M174.08,178.311V290.95c0,26.821,12.956,50.674,32.938,65.625l14.336-3.587l18.091,18.2  c5.348,1.102,10.884,1.683,16.554,1.683c5.64,0,11.147-0.573,16.47-1.664l20.65-17.194l11.862,2.531  c19.974-14.952,32.938-38.78,32.938-65.593v-112.64H174.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.08,
    y: 178.31,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.616,
    y: 178.31,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.152,
    y: 178.31,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.848,
    y: 211.078,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.384,
    y: 211.078,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.08,
    y: 243.834,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.848,
    y: 276.602,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.616,
    y: 243.834,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.152,
    y: 243.834,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.384,
    y: 276.602,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.616,
    y: 309.37,
    style: {
      fill: "#D80027"
    },
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M206.848,309.375h-30.653c2.812,12.18,8.338,23.327,15.919,32.768h14.734L206.848,309.375   L206.848,309.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M305.152,342.143h14.734c7.581-9.441,13.106-20.588,15.919-32.768h-30.653V342.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M206.848,342.143v14.298c9.531,7.17,20.667,12.314,32.768,14.78v-29.078H206.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M272.384,342.143v29.078c12.101-2.466,23.237-7.61,32.768-14.78v-14.298H272.384z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg134Croatia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };